export default __webpack_public_path__ + "static/media/iread2.42f29a7c.jpeg";